module.exports = __webpack_public_path__ + "static/media/exo-latin-700italic.b5ca65aa.woff";